export { default, Logger, pinoLogger } from './logger.browser'
export { slimError, type SlimError } from './lib/slimError'
export type { LoggerConfig } from './types'

/** Browser/edge counterpart of the node export. Nothing to flush here. */
export async function flushPosthogLogs(_timeoutMs?: number): Promise<void> {}

/**
 * Browser/edge counterpart of the node export, so the package's public surface
 * is the same shape under every export condition. Always `''`: there is no
 * container here, and importing the real one would pull `node:os` into a client
 * bundle. Without this the symbol type-checks for browser consumers and is
 * `undefined` at runtime.
 */
export function containerHostnameFor(_service?: string, _env?: string): string {
  return ''
}
